export const secondaryButtonStyles = {
  py: 1.4,
  px: 3.5,
  borderRadius: 999,
  fontWeight: 700,
};